import React from 'react';
import { useTranslation } from 'react-i18next';
import Badge from '../../../components/v2/Badge/Badge';
import Button from '../../../components/v2/Button/Button';
import Icon from '../../../components/v2/Icon/Icon';
import { useBasketItems } from '../hooks';
import useBasketModal from '../hooks/useBasketModal';

const BasketButton = () => {
  const { t } = useTranslation();
  const { itemsCount } = useBasketItems();
  const openBasketModal = useBasketModal();

  return (
    <Badge expand badgeContent={itemsCount}>
      <Button
        onClick={openBasketModal}
        startIcon={<Icon name={'fas fa-files'} />}
        expand
      >
        {t('Basket')}
      </Button>
    </Badge>
  );
};

export default BasketButton;
